import Alpine from "alpinejs";

/**
 * This sets up Alpine for handling program form displaying across the site
 */
Alpine.store('programModal', {
    show: false,
    html: '',
    template: 'program-modal',

    fetchModal() {

        // Add loading.
        this.updateButtonLoadingState(true);

        // Store 'this' in a var.
        var alp = this;
        $.post(
            // eslint-disable-next-line no-undef
            sageAjax.ajaxUrl,
            {
                action: 'get_modal',
                template: this.template,
                dataType: "html",
            }
        )
            .done(
                function (data) {
                    alp.html = data;
                    $('#app').append(alp.html);
                }
            )
            .fail(
                function () {

                }
            )
            .always(
                function () {
                    // Update button states when loading ends.
                    alp.updateButtonLoadingState(false);
                }
            );

        this.html = alp.html;
    },
    updateButtonLoadingState(isLoading) {
        const buttons = document.querySelectorAll('[data-x-bind="programShow"]');
        buttons.forEach(button => {
            if (isLoading) {
                button.classList.add('loading');
            } else {
                button.classList.remove('loading');
                // Check if there are no class names left on the button/link.
                // Standard links are styled differently if no class attribute is present.
                if (button.className === '') {
                    button.removeAttribute('class');
                }
            }
        });
    },
    showModal() {
        // If we haven't already loaded the modal, do it now.
        if (this.html === '') {
            this.fetchModal()
        }
        this.show = true;
    },
    hideModal() {
        this.show = false;
    },
    toggle() {
        this.show = !this.show;
    },
});

// @todo: this could be refactored into one more concise binding to control `x-show`, `@click`, `@click.away`, etc.

Alpine.bind('programShow', () => ({
    type: 'button',
    'data-x-on:click'(e) {
        e.preventDefault();
        Alpine.store('programModal').showModal();
    },
}));

Alpine.bind('programHide', () => ({
    type: 'button',
    'data-x-on:click'(e) {
        e.preventDefault();
        Alpine.store('programModal').hideModal();
    },
}));

